import { useEffect, useState } from "react";

import { useRouter } from "next/router";

import { adminGetCreatorInfo, getCanEditProduct } from "~/api/creatorApi";
import { CreatorInfo } from "~/api/userApi";
import { useAuth } from "../auth/useAuth";

const useVerifyAsCreatorOrAdmin = (
  productId?: string,
) => {

  const { user, loadingCurrentUser } = useAuth();
  const [canEditProduct, setCanEditProduct] = useState(false);
  const [loadingCreatorVerification, setLoadingCreatorVerification] = useState(true);
  const [adminCreatorSlug, setAdminCreatorSlug] = useState<string>()
  const [adminUrlParam, setAdminUrlParam] = useState<string>("")
  const [adminCreatorInfo, setAdminCreatorInfo] = useState<CreatorInfo>()
  //const [isAdminSlugReset, setIsAdminSlugReset] = useState(false);
  const router = useRouter();

  const addAdminSlugInCookies = () => {
    if(adminCreatorSlug){
      localStorage.setItem("adminCreatorSlug", adminCreatorSlug);
    }
  };
  
  const removeAdminSlugFromCookies = () => {
    localStorage.removeItem("adminCreatorSlug");
  };

  // Initialize to remove ability to make API calls as admin.
  // useEffect(() => {
  //   removeAdminSlugFromCookies();
  //   setIsAdminSlugReset(true);

  //   return () => {
  //     removeAdminSlugFromCookies();
  //   };
  // }, []);


  // Redirect away from page if not a creator or not an admin allowed to edit this product.
  useEffect(() => {

    if (loadingCreatorVerification) {
      return;
    }

    if (
      (!loadingCurrentUser && !user) ||
      (!loadingCurrentUser && !user?.creatorInfo?.canCreateClasses && !canEditProduct)
    ){
      router.push("/");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, loadingCurrentUser, canEditProduct, loadingCreatorVerification]);


    // Ensures the creator or creator slug matches the product being edited.
    useEffect(() => {
      if(adminCreatorSlug !== undefined){
        if (!productId){
          addAdminSlugInCookies();
          setCanEditProduct(true);
          setLoadingCreatorVerification(false);
        } else {
          getCanEditProduct(productId, adminCreatorSlug)
            .then(canEdit => {
              setCanEditProduct(canEdit);
              if(canEdit){
                addAdminSlugInCookies();
              }
              setLoadingCreatorVerification(false);
            }).catch(() => {
              setCanEditProduct(false);
              setLoadingCreatorVerification(false);
          })
        }
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productId, adminCreatorSlug]);


  // Handles extracting the slug from the url and storing it in state.
  useEffect(() => {
    if (router.isReady) {
      const { adminCreatorSlug } = router.query;
      const slug = Array.isArray(adminCreatorSlug) ? adminCreatorSlug[0] : adminCreatorSlug;
      setAdminCreatorSlug(slug || "");
      setAdminUrlParam(slug ? `?adminCreatorSlug=` + slug : "")

      if (slug) {
        adminGetCreatorInfo(slug)
          .then((creatorInfo) => setAdminCreatorInfo(creatorInfo))
      } else {
        removeAdminSlugFromCookies();
      }
    }

    return () => {
      const { adminCreatorSlug } = router.query;
      const slug = Array.isArray(adminCreatorSlug) ? adminCreatorSlug[0] : adminCreatorSlug;
      if (!slug) {
        removeAdminSlugFromCookies();
      }
    };
  }, [router.query, router.isReady]);


  return {
    adminCreatorSlug,
    adminUrlParam,
    loadingCreatorVerification,
    canEditProduct,
    adminCreatorInfo
  };
};

export default useVerifyAsCreatorOrAdmin;
